import React from 'react';
import Content from '../../components/Pages/auth/SingleSignIn';
import GuidanceAuthLayout from '../../components/Layout/Auth';

function SignInGuidance() {
  document.title = 'Guidance: Single Sign On';

  return (
    <GuidanceAuthLayout>
      <Content />
    </GuidanceAuthLayout>
  );
}

export default SignInGuidance;
